import React from 'react';

import { createEntity } from '../../animal-species/animal-species.reducer';
import { ModalCreateEntity } from '../../../shared/components/modal-create-entity';

export const ModalAnimalSpeciesCreate = () => {
  return <ModalCreateEntity createEntity={createEntity} entityKey="animalSpecies" />;
};
